export const FEATURE_NAME = '@zerops/zui/port-routing-item';
